import React from 'react';
import { GeckoIcon } from 'ui';
import './index.scss';

const AILoader = (props) => {
  const { isLoading, children, loadingText } = props;

  return (
    <div className="ai-loader-bg">
      {isLoading && (
        <div className="ai-loader">
          <GeckoIcon icon="far fa-sparkles fa-spin" />
          <p>{loadingText}</p>
        </div>
      )}
      <div className={isLoading && 'blur'}>{children}</div>
    </div>
  );
};

export default AILoader;
